module.exports = __webpack_public_path__ + "static/media/ic-meal-switch.582132c0.svg";